import { Product } from '../DashBoard/DashBoardScreen'

export type ProductKeyMap = {
  [key in Product]?: {
    displayKey: { language: { en: string; sv: string } }
    dataKey: string
    icon?: any
    type: string
    required?: boolean
  }[]
}

export const productKeyMap: ProductKeyMap = {
  [Product.OATS]: [
    {
      displayKey: { language: { sv: 'Köpare', en: '' } },
      dataKey: 'company',
      icon: 'cash',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Kval. Regl. vikt kg', en: '' } },
      dataKey: 'qualityAdjusted',
      icon: 'levKvantKg',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Vattenhalt %', en: '' } },
      dataKey: 'waterContent',
      icon: 'waterContent',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Avfall %', en: '' } },
      dataKey: 'waste',
      icon: 'waste',
      type: 'text',
    },

    {
      displayKey: { language: { sv: 'Rymdvikt g/l', en: '' } },
      dataKey: 'density',
      icon: 'density',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Lev. datum', en: '' } },
      dataKey: 'settlementDate',
      icon: 'shippingCost',
      type: 'date',
    },
    {
      displayKey: { language: { sv: 'Summa kr. totalt', en: '' } },
      dataKey: 'totalPrice',
      icon: 'moneyBag',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Bruttopris', en: '' } },
      dataKey: 'grossPrice',
      icon: 'moneyBag',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Nettovikt ton', en: '' } },
      dataKey: 'netWeight',
      icon: 'levKvantKg',
      type: 'text',
    },

    {
      displayKey: { language: { sv: 'Rymdvikt kr/ton', en: '' } },
      dataKey: 'densityDeduction',
      icon: 'densityDeduction',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Fullkorn %', en: '' } },
      dataKey: 'wholeGrain',
      icon: 'wholeGrain',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Havre färg', en: '' } },
      dataKey: 'oatColor',
      icon: 'oatColor',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'DON ppb', en: '' } },
      dataKey: 'don',
      icon: 'don',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Invägd vikt ton', en: '' } },
      dataKey: 'weighIn',
      icon: 'levKvantKg',
      type: 'text',
    },

    {
      displayKey: { language: { sv: 'Varav fullkorn ton', en: '' } },
      dataKey: 'partWholeGrain',
      icon: 'partWholeGrain',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Korr. rymdvikt ton', en: '' } },
      dataKey: 'correctedDensity',
      icon: 'densityDeduction',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Spotpris kr/ton', en: '' } },
      dataKey: 'unitPrice',
      icon: 'unitPrice',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Spotpris nedklass vara kr/ton', en: '' } },
      dataKey: 'unitPriceReduced',
      icon: 'unitPriceReduced',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Spotpris nedklass totalt kr', en: '' } },
      dataKey: 'unitPriceReducedTotal',
      icon: 'unitPrice',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Fraktkostnad inkl. ortsjust kr', en: '' } },
      dataKey: 'shippingCost',
      icon: 'shippingCost',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Analyskostnad kr', en: '' } },
      dataKey: 'analysisCost',
      icon: 'analysisCost',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Forskningsavgift SLF 0,2 % kr', en: '' } },
      dataKey: 'researchCost',
      icon: 'researchCost',
      type: 'text',
    },

    {
      displayKey: { language: { sv: 'Leverantörs nr.', en: '' } },
      dataKey: 'supplierId',
      icon: 'shippingCost',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Avdelning', en: '' } },
      dataKey: 'houseId',
      icon: 'shippingCost',
      type: 'text',
    },
  ],

  [Product.RAPESEED]: [
    {
      displayKey: { language: { sv: 'Köpare', en: '' } },
      dataKey: 'company',
      icon: 'cash',
      type: 'text',
      required: true,
    },
    {
      displayKey: { language: { sv: 'Avräkningspris SEK', en: '' } },
      dataKey: 'unitPrice',
      icon: 'moneyBag',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Invägd vikt ton', en: '' } },
      dataKey: 'weighIn',
      icon: 'levKvantKg',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Vattenhalt %', en: '' } },
      dataKey: 'waterContent',
      icon: 'waterContent',
      type: 'text',
    },

    {
      displayKey: { language: { sv: 'Avrens %', en: '' } },
      dataKey: 'waste',
      icon: 'waste',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Oljehalt %', en: '' } },
      dataKey: 'oilContent',
      icon: 'oilContent',
      type: 'text',
    },

    {
      displayKey: { language: { sv: 'Klorofyll %', en: '' } },
      dataKey: 'chlorophyll',
      icon: 'protein',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Lev. datum', en: '' } },
      dataKey: 'settlementDate',
      icon: 'shippingCost',
      type: 'date',
      required: true,
    },
    {
      displayKey: { language: { sv: 'Vattenhalt SEK/ton', en: '' } },
      dataKey: 'waterContentCostPerTon',
      icon: 'waterContent',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Vattenhalt Total SEK', en: '' } },
      dataKey: 'waterContentCostTotal',
      icon: 'waterContent',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Avrens Total SEK', en: '' } },
      dataKey: 'wasteCostTotal',
      icon: 'waste',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Avrens SEK/ton', en: '' } },
      dataKey: 'wasteCostPerTon',
      icon: 'waste',
      type: 'text',
    },

    {
      displayKey: { language: { sv: 'Oljehalt SEK/ton', en: '' } },
      dataKey: 'oilContentCostPerTon',
      icon: 'oilContent',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Oljehalt Totalt SEK', en: '' } },
      dataKey: 'oilContentCostTotal',
      icon: 'oilContent',
      type: 'text',
    },

    {
      displayKey: { language: { sv: 'Grundersättning SEK/ton', en: '' } },
      dataKey: 'basicBenefitPerTon',
      icon: 'unitPrice',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Grundersättning Totalt SEK', en: '' } },
      dataKey: 'basicBenefitTotal',
      icon: 'unitPrice',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Kvalitetsreglering SEK/ton', en: '' } },
      dataKey: 'qualityAdjustedPerTon',
      icon: 'unitPrice',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Kvalitetsreglering Totalt SEK', en: '' } },
      dataKey: 'qualityAdjustedTotal',
      icon: 'unitPrice',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Frakt SEK/ton', en: '' } },
      dataKey: 'shippingCostPerTon',
      icon: 'shippingCost',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Frakt Totalt SEK', en: '' } },
      dataKey: 'shippingCostTotal',
      icon: 'shippingCost',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Analyskostnad SEK', en: '' } },
      dataKey: 'analysisCost',
      icon: 'analysisCost',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Korrigerad delsumma SEK', en: '' } },
      dataKey: 'adjustedSubTotal',
      icon: 'moneyBag',
      type: 'text',
    },

    {
      displayKey: { language: { sv: 'Summa att utbetala', en: '' } },
      dataKey: 'totalPrice',
      icon: 'moneyBag',
      type: 'text',
    },

    {
      displayKey: { language: { sv: 'Leverantörs nr.', en: '' } },
      dataKey: 'supplierId',
      icon: 'shippingCost',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Avdelning', en: '' } },
      dataKey: 'houseId',
      icon: 'shippingCost',
      type: 'text',
    },
  ],
  [Product.FODER]: [
    {
      displayKey: { language: { sv: 'Säljare', en: 'Supplier' } },
      dataKey: 'company',
      icon: 'cash',
      type: 'text',
      required: true,
    },
    {
      displayKey: { language: { sv: 'Kvantitet', en: 'Quantity' } },
      dataKey: 'quantity',
      icon: 'levKvantKg',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Momsgrund', en: 'Pre-VAT' } },
      dataKey: 'preVAT',
      icon: 'moneyBag',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Fakturadatum', en: 'Settlement date' } },
      dataKey: 'settlementDate',
      icon: 'shippingCost',
      type: 'date',
      required: true,
    },
    {
      displayKey: { language: { sv: 'Kundnummer', en: 'Customer Id' } },
      dataKey: 'supplierId',
      icon: 'cash',
      type: 'text',
    },

    {
      displayKey: { language: { sv: 'Pris', en: 'Price' } },
      dataKey: 'price',
      icon: 'cash',
      type: 'text',
    },
  ],
  [Product.DIESEL]: [
    {
      displayKey: { language: { sv: 'Säljare', en: 'Supplier' } },
      dataKey: 'company',
      icon: 'cash',
      type: 'text',
      required: true,
    },
    {
      displayKey: { language: { sv: 'Kvantitet', en: 'Quantity' } },
      dataKey: 'quantity',
      icon: 'levKvantKg',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Momsgrund', en: 'Pre-VAT' } },
      dataKey: 'preVAT',
      icon: 'moneyBag',
      type: 'text',
    },
    {
      displayKey: { language: { sv: 'Fakturadatum', en: 'Settlement date' } },
      dataKey: 'settlementDate',
      icon: 'shippingCost',
      type: 'date',
      required: true,
    },
    {
      displayKey: { language: { sv: 'Kundnummer', en: 'Customer Id' } },
      dataKey: 'supplierId',
      icon: 'cash',
      type: 'text',
    },

    {
      displayKey: { language: { sv: 'Pris', en: 'Price' } },
      dataKey: 'price',
      icon: 'cash',
      type: 'text',
    },
  ],
}
